import { getSortablePeriodLabels, getProDisplayName } from '..';

/**
 * Get a statement label like "ASCAP 2020 Q1" from a statement view. Formatting of the date range
 * may be different if the start_date or end_date is not aligned with a quarter.
 * @param statementView
 * @returns {string}
 */
export const getStatementLabel = (statementView: TrqkStatementView): string => {
    const { pro, region } = statementView;

    const start_date = statementView.start_date ?? null;
    const end_date = statementView.end_date ?? null;

    const periodLabels = getSortablePeriodLabels({
        start_date,
        end_date,
    });

    const dateLabel =
        periodLabels.short ||
        periodLabels.long ||
        `${start_date} to ${end_date}`;

    const proDisplayName = pro ? getProDisplayName(pro, region) : null;

    if (proDisplayName) {
        return `${proDisplayName} ${dateLabel}`;
    }

    return dateLabel;
};
